module.exports = __webpack_public_path__ + "static/media/video1.e3820c76.png";


//////////////////
// WEBPACK FOOTER
// ./src/modules/theme/components/images/video1.png
// module id = 971
// module chunks = 0